import {MI} from "../init";
import MadnesTween from "../libs/mi/MadnesTween";

/**
 * @constructor
 * @returns {GameBonus}
 */
export function GameBonus() {

    /** @type {Game} */
    this._game;

    this._inBonus = false;

    /** @type {GameGroups} */
    this._groups;

    /** @type {GameAssets} */
    this._assets;

    /** @type {SpinReels} */
    this._spinReels;

    /** @type {GameMemory} */
    this._memory;

    /** @type {Object<string,MadnesAudio>} */
    this._sounds;

    /** @type {?MadnesTween} */
    this._bgInTween = null;

    /** @type {?MadnesTween} */
    this._bgOutTween = null;
}

GameBonus.prototype.inBonus = function() {
    return this._inBonus;
};

/**
 * @param {Game} game
 */
GameBonus.prototype.init = function(game) {
    this._game = game;
    this._sounds = game.sounds;
    this._groups = game.groups;
    this._assets = game.assets;
    this._memory = game.memory;
    this._spinReels = game.spinReels;

    /** @type {Array<ReelBonus>} */
    this._reelBonus = [];

};

GameBonus.prototype.isInBonus = function() {

    var wildMemory = this._memory.getWildMemory();

//	console.log(this._game.lastRoundEnded, wildMemory['featureCount'], wildMemory['featureNumber'], this.getBonusType());

//	if(this._game.lastRoundEnded) {
//		if(wildMemory['featureCount'] < 1) {
//			return this.inBonus();
//		} else if(wildMemory['featureCount'] === wildMemory['featureNumber']) {
//			return false;
//		} else {
//			return true;
//		}
//	}
//	else
//	{
//		if(wildMemory['featureCount'] < 1) {
//			return !!this.getBonusType();
//		} else if(wildMemory['featureCount'] === wildMemory['featureNumber']) {
//			return true;
//		} else {
//			return true;
//		}
//	}


    if(wildMemory['featureCount'] < 1) {

        return !!this.getFeatureType();

    } else if(wildMemory['featureCount'] === wildMemory['featureNumber']){

        return false;

    } else {
        //console.log(wildMemory['featureNumber'] > 0 && wildMemory['featureCount'] !== wildMemory['featureNumber']);
        return wildMemory['featureNumber'] > 0;
    }

//	return wildMemory['featureCount'] > 0 && wildMemory['featureNumber'] > 0 && wildMemory['featureCount'] !== wildMemory['featureNumber'];
    //return wildMemory['featureCount'] !== wildMemory['featureNumber'] && wildMemory['featureNumber'] > 0;
};

GameBonus.prototype.check = function() {

    this.isInBonus() ? this.setBonus() : this.unsetBonus();
};

GameBonus.prototype.checkEnd = function() {
    this.check();
    //this.isInBonus() ? this.setBonus() : this.unsetBonus();
};

GameBonus.prototype.createReels = function() {
    this._reelBonus[0] = new ReelBonus();
    this._reelBonus[0].create(204 - 10, this._groups);
    this._reelBonus[1] = new ReelBonus();
    this._reelBonus[1].create(1062 + 30, this._groups);
};

/**
 * @param {string} type
 * @returns {ReelBonus}
 */
GameBonus.prototype.getBonusReel = function(type) {
    return type === "left" ? this._reelBonus[0] : this._reelBonus[0];
};

GameBonus.prototype.setReels = function() {

    this._reelBonus[0].play("left");
    this._reelBonus[0].show();
    this._reelBonus[0].setAlpha(1);

    this._spinReels.getReelManager(0).hideReel();

    if(this.getBonusType() === "double") {
        this._reelBonus[1].play("right");
        this._reelBonus[1].show();
        this._reelBonus[1].setAlpha(1);

        this._spinReels.getReelManager(3).hideReel();
    }
};

GameBonus.prototype.unsetReels = function() {

    //console.warn("unsetReels");

    this._reelBonus[0].stop();
    this._reelBonus[1].stop();

    this._reelBonus[0].hide();
    this._reelBonus[1].hide();

    this._spinReels.getReelManager(0).showReel();
    this._spinReels.getReelManager(3).showReel();

    if(this._memory.getNoJBReel()) {
        var reelLeft = this._memory.getNoJBReel()[0];
        var reelRight = this._memory.getNoJBReel()[1];

        this._spinReels.getReel(0).setReelMatrix(reelLeft);
        this._spinReels.getReel(3).setReelMatrix(reelRight);

        this._spinReels.getReelManager(0).transformResSymbols();
        this._spinReels.getReelManager(3).transformResSymbols();
    }

//	if(this._memory.getNoJBReel().length === 3) {
//		reelLeft = this._memory.getNoJBReel();
//		reelRight = reelLeft;
//	}
};

GameBonus.prototype._fadeInReels = function() {

    var _self = this;

    MI.createTimer().add(function() {
        _self._sounds["bonus_joker"].play();
    }, 200);

    return new Promise(function(res) {

        _self._reinitReels();

        _self._reelBonus[0].play("left");

        _self._reelBonus[0].show();
        _self._reelBonus[0].setAlpha(0);

        _self._animReel(_self._reelBonus[0], res);

        if(_self.getBonusType() === "double") {

            _self._spinReels.getReelManager(3).hideReel();

            _self._reelBonus[1].play("right");
            _self._reelBonus[1].show();
            _self._reelBonus[1].setAlpha(0);

            _self._animReel(_self._reelBonus[1]);
        }
    });
};

GameBonus.prototype._reinitReels = function() {
//		_self._spinReels.getReelManager(0).showReel();
//		_self._reelBonus[0].stop();
//		_self._reelBonus[0].hide();

    this._reelBonus[1].stop();
    this._reelBonus[1].hide();
    this._spinReels.getReelManager(3).showReel();
};

GameBonus.prototype.pulseReels = function() {

    this._pulseReel(this._reelBonus[0]);
    if(this.getBonusType() === "double") {
        this._pulseReel(this._reelBonus[1]);
    }
};

/**
 * @param {ReelBonus} reel
 * @param {Function=} cb
 */
GameBonus.prototype._animReel = function(reel, cb) {
    this._fadeInReel(reel, cb);
    this._pulseReel(reel);
};

/**
 * @param {ReelBonus} reel
 * @param {Function=} cb
 */
GameBonus.prototype._fadeInReel = function(reel, cb) {

    MI.addTween().to(reel.smoke, { 'alpha': 1 }, {
        'duration': 200
    });

    MI.addTween().to(reel.sparkle, { 'alpha': 1 }, {
        'duration': 200,
        'callback': function() {
            cb && cb();
        }
    });
};

/** @param {ReelBonus} reel */
GameBonus.prototype._pulseReel = function(reel) {
    MI.addTween().to(reel.smoke, { 'x': 1.2, 'y': 1.2 }, {
        'scale': true,
        'duration': 100,
        'yoyo': true,
        'callback': function() {
            reel.smoke.setScale(1, 1);
        }
    });

    MI.addTween().to(reel.sparkle, { 'x': 1.2, 'y': 1.2 }, {
        'scale': true,
        'duration': 100,
        'yoyo': true,
        'callback': function() {
            reel.sparkle.setScale(1, 1);
        }
    });
};

GameBonus.prototype.getFeatureType = function() {

    var wildMemory = this._memory.getWildMemory();

    if(!wildMemory) {
        return "";
    }

    switch(wildMemory["featureType"]) {
        case 0:
            return "single";
        case 1:
            return "double";
        case 2:
            return "single";
        case 3:
            return "double";
        default:
            return "";
    }
};

GameBonus.prototype.getBonusType = function() {
    return "double";
};

GameBonus.prototype.getNoJBReel = function() {
    return this._memory.getNoJBReel();
};

/**
 * @returns {boolean}
 */
GameBonus.prototype.isBonus = function() {
    return !!this.getBonusType();
};

GameBonus.prototype.setBonus = function() {

    this._inBonus = true;

    this._fadeInBg();

    this.startPlayBonusBg();

    var wildMem = this._memory.getWildMemory();

    var bsNumber = wildMem["featureNumber"];
    var bsCount = wildMem["featureCount"];

    this._assets.header.setBoomSpinsCount(bsNumber - bsCount);

    this._assets.header.set("bonus");

    this.setReels();
};

GameBonus.prototype.startPlayBonusBg = function() {

    if(!this._sounds["audio_bonus_bg"].isPlaying()) {
        this._sounds["audio_bonus_bg"].loop();
        this._sounds["audio_bonus_bg"].setVolume(0);
    }

    this._sounds["audio_bonus_bg"].fadeToInit(1000);
};

GameBonus.prototype.unsetBonus = function() {

    this._fadeOutBg();
    this._assets.header.set("logo");

    this.unsetReels();

    this._sounds["audio_bonus_bg"].fadeOut(400, true);

    this._inBonus = false;
};

/**
 * @returns {Promise}
 */
GameBonus.prototype.enterBonus = function() {

    var _self = this;

    this._fadeInBg();

    this._inBonus = true;

    var wildMem = this._memory.getWildMemory();

    var bsNumber = wildMem["featureNumber"];
    var bsCount = wildMem["featureCount"];

    this._assets.header.setBoomSpinsCount(bsNumber - bsCount);
    this._assets.header.show("bonus");

    MI.createTimer().add(function() {

        _self._spinReels.getReelManager(0).hideReel();
        if(_self.getBonusType() === "double") {
            _self._spinReels.getReelManager(3).hideReel();
        }
    }, 100);

    return this._fadeInReels();
};

//GameBonus.prototype.leaveBonus = function() {
//
//	var _self = this;
//
//	return new Promise(function(res) {
//	});
//};

GameBonus.prototype._fadeInBg = function() {

    var _self = this;

    _self._stopTweens();

    if(_self._bgInTween /*|| _self._inBonus*/) {
//		res();
        return;
    }

//	_self._inBonus = true;

    _self._assets.bgBonus.setVisible(true);
//	_self._assets.bgBonus.setAlpha(0);

    _self._bgInTween = MI.addTween().to(_self._assets.bgBonus, { 'alpha': 1 }, {
        'duration': 200,
        'callback': function() {
            _self._assets.bg.setVisible(false);
            _self._bgInTween = null;
//			res();
        }
    });
};

GameBonus.prototype._fadeOutBg = function() {

    var _self = this;

    _self._stopTweens();

    if(_self._bgOutTween /*|| !_self._inBonus*/) {
//		res();
        return;
    }

    _self._assets.bg.setVisible(true);
    _self._assets.bg.setAlpha(1);

    _self._bgOutTween = MI.addTween().to(_self._assets.bgBonus, { 'alpha': 0 }, {
        'duration': 200,
        'callback': function() {

            _self._bgOutTween = null;
//			_self._inBonus = false;

            _self._assets.bgBonus.setVisible(false);

//			res();
        }
    });
};

GameBonus.prototype._stopTweens = function() {

    this._bgInTween && this._bgInTween.stop();
    this._bgInTween = null;

    this._bgOutTween && this._bgOutTween.stop();
    this._bgOutTween = null;
};

/**
 * @constructor
 * @returns {undefined}
 */
function ReelBonus() {

    /** @type {MadnesObject} */
    this.sparkle;

    /** @type {MadnesObject} */
    this.smoke;

    /** @type {?MadnesTween} */
    this._tweenMove = null;

    /** @type {?MadnesTween} */
    this._tweenScale = null;

    /** @type {number} */
    this._x = 0;

    this._y = -16;
}

/**
 * @param {number} x
 * @param {GameGroups} groups
 */
ReelBonus.prototype.create = function(x, groups) {

    this._x = x;

    this.smoke = MI.addImg(x - 6, MI.getHe() / 2 + this._y, "boomspins_atlas").setFrameName("symbol_Wild-big_background");
    this.smoke.setAnchor(0.5, 0.5);
    this.smoke.setVisible(false);

    groups.get("group_pre_cover").add(this.smoke);

    this.sparkle = MI.addImg(x, MI.getHe() / 2 + this._y, "boomspins_atlas").setFrameName("symbol_bigWild_00000");
    this.sparkle.setAnchor(0.5, 0.5);
    this.sparkle.setVisible(false);
};

ReelBonus.prototype.play = function(type) {

    if(this._tweenMove !== null) {
        return;
    }

    var angle = -1;
    var xPos = -6;

    if(type === "left") {
        angle *= -1;
        xPos *= -1;
    }

    this.smoke.setAngle(angle);

    this._tweenMove = MI.addTween().to(this.smoke, { 'angle': angle * -1, 'x': this._x + xPos * -1 }, {
        'duration': 2500,
        'count': -1,
        'yoyo': true,
        'easing': MadnesTween.getEasing("sinusoidal_in_out")
    });

    this._tweenScale = MI.addTween().to(this.smoke, { 'x': 0.98, 'y': 0.98 }, {
        'scale': true,
        'duration': 1250,
        'yoyo': true,
        'count': -1,
        'easing': MadnesTween.getEasing("sinusoidal_in_out")
    });
};

ReelBonus.prototype.pause = function() {
    this._tweenMove && this._tweenMove.pause();
    this._tweenScale && this._tweenScale.pause();
};

ReelBonus.prototype.resume = function() {
    this._tweenMove && this._tweenMove.resume();
    this._tweenScale && this._tweenScale.resume();
};

ReelBonus.prototype.stop = function() {
    this._tweenMove && this._tweenMove.stop();
    this._tweenMove = null;

    this._tweenScale && this._tweenScale.stop();
    this._tweenScale = null;
};

ReelBonus.prototype.show = function() {
    this.smoke.setVisible(true);
    this.sparkle.setVisible(true);
};

ReelBonus.prototype.hide = function() {
    this.smoke.setVisible(false);
    this.sparkle.setVisible(false);
};

/** @param {number} alpha */
ReelBonus.prototype.setAlpha = function(alpha) {
    this.smoke.setAlpha(alpha);
    this.sparkle.setAlpha(alpha);
};